module.exports = __webpack_public_path__ + "static/media/Projects_top.f229dd6e.png";